import React from 'react'
import bandMountain from '../images/DSC08125.jpg'
import Album from '../components/Album'
import { Helmet } from 'react-helmet-async'
import { FaItunes, FaSpotify } from 'react-icons/fa'

const Home = () => {
  return (
    <>
      <Helmet>
        <title>The Asheville Mountain Boys - Home</title>
        <meta
          name="description"
          content="The Asheville Mountain Boys music and merch."
        />
        <link rel="canonical" href="/home" />
      </Helmet>
      <div className="bg-slate-50 pt-20 md:pt-0">
        <div className="">
          <img
            src={bandMountain}
            alt="The band performing."
            className="w-full "
          />
        </div>

        <div className="text-center">
          <h1 className="text-xl p-6 ">
            New album,{' '}
            <span className="italic font-bold">
              The Asheville Mountain Boys
            </span>
            {', '}
            available now.
          </h1>

          <div className="flex justify-center items-center gap-6 p-3">
            <a
              href="https://open.spotify.com/album/5xDbHCBG7CHZtzwU54FXnm?si=-ra53jrGRue423TR3eP7bQ"
              target="_blank"
            >
              <button className="flex items-center gap-2 rounded bg-indigo-200 text-cyan-600 font-bold py-2 px-4 tracking-widest lg:mb-4 hover:opacity-80 duration-500 shadow-xl">
                STREAM <span className="font-normal">//</span>
                <FaSpotify className="text-green-500 text-3xl cursor-pointer" />
              </button>
            </a>

            <a
              href="https://music.apple.com/us/album/the-asheville-mountain-boys/1867072559"
              target="_blank"
            >
              <button className="flex items-center gap-2 rounded bg-indigo-200 text-cyan-600 font-bold py-2 px-4 tracking-widest lg:mb-4 hover:opacity-80 duration-500 shadow-xl">
                STREAM <span className="font-normal">//</span>
                <FaItunes className="text-pink-600 text-3xl" />
              </button>
            </a>
          </div>
        </div>

        <div className="justify-center flex p-6 pt-">
          <iframe
            width="100%"
            height="400"
            src="https://www.youtube.com/embed/fKYUsNNEgQE?si=5abi9v1hXY6pGe4Z"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            className=" max-w-3xl"
          ></iframe>
        </div>

        <div>
          <Album />
        </div>
      </div>
    </>
  )
}

export default Home
